import { createAction } from 'typesafe-actions';
import { IDivision } from '../../../types/model/rights/division';

export default class DivisionActions {
    public static setLoading = createAction('RIGHTS_DIVISION_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
    public static setList = createAction('RIGHTS_DIVISION_SET', resolve => (blocks : Array<IDivision>) => resolve(blocks));
}